import { createSlice } from '@reduxjs/toolkit'

export const lastSlice = createSlice({
  name: "last",
  initialState: {
    last: []
  },
  reducers: {
    addToLast: (state, action) => {
      state.last.push(action.payload)
    },
    updateLast: (state) => {
      state.last.shift()
    },
    reInitLast: (state) => {
      state.last = []
    }
  }
})

export const { addToLast, updateLast, reInitLast } = lastSlice.actions

export default lastSlice.reducer